import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { FollowersGrowthHeading } from "../../../../../utils/Constant";
import ReactApexChart from "react-apexcharts";
import { growthChartData } from "../../../../../Data/Widgets/WidgetsChartData";

const FollowersGrowth = () => {
  return (
    <Col xl="12">
      <Card className="growth-wrap">
        <CardHeaderCommon headClass="pb-0" title={FollowersGrowthHeading} firstItem="Weekly" secondItem="Monthly" thirdItem="Yearly" />
        <CardBody>
          <div className="growth-wrapper">
            <ReactApexChart options={growthChartData} series={growthChartData.series} type="line" height={135}  />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default FollowersGrowth;
